import React from 'react';
import './Hero.css';
//import heroVideo from '../../public/assets/your-video.mp4'; // Replace with your video path

const Hero = () => {
  return (
    <section className="hero">
      <div className="video-background">
        <video autoPlay muted loop className="video-element">
          <source src="/animation.mp4" type="video/mp4" />
        </video>
      </div>

      <div className="hero-text">
        <h1 className="hero-title">
        <span class="highlight">Unlock Expertise</span>,<br></br>
         <span class="highlight">Grow Your Network</span>,<br></br>
          <span class="highlight">Monetise Knowledge</span>
        </h1>
        <p className="hero-subtitle">
          Join the most exclusive network of top professionals
        </p>
        <div className="hero-buttons">
          <a href="https://forms.gle/Kc3TSpbzVNeNotHS9" target="_blank" rel="noopener noreferrer" className="cta-btn">Apply as an Expert</a>  
          <a href="https://forms.gle/2FUcDTEbr4Kh3ES56" target="_blank" rel="noopener noreferrer" className="cta-btn2">Request a Demo</a>
        </div>
      </div>
      {/* <div className="hero-media">
        <video
          src={"/platform.mp4"}
          autoPlay
          loop
          muted
          playsInline
          className="/platform.mp4"
        ></video>
      </div> */}
    </section>
  );
};

export default Hero;

// import React from 'react';
// import './Hero.css';

// function Hero() {
//   return (
//     <section className="hero">
//       <div className="hero-content">
//         <div className="hero-title">Unlock Expertise, <br></br>Grow Your Network,<br></br> Monetise Knowledge</div>
//         <div className="hero-subtitle">Join the most exclusive network of top professionals</div>
//         <div className="hero-buttons">
//           <a href="#apply" className="cta-btn">Apply as an Expert</a>
//           <a href="#demo" className="cta-btn2">Request a Demo</a>
//         </div>
//         <div className="hero-img">
//         <video
//           src={"/platform.mp4"}
//           autoPlay
//           loop
//           muted
//           playsInline
//           className="/platform.mp4"
//         ></video>
//       </div>
//       </div>
//     </section>
//   );
// }

// export default Hero;
